/**
 * English for the campaign editor (card У4, boards ESource, EOffers, ERules,
 * ERuleDialog, EBranches, EDomain, ECost, EPostbacks, EReview, ELinkReady,
 * EUnsaved). Spread into `en`, so the keys are part of `TKey` and
 * `ru.editor.ts` must cover every one of them.
 */
export const enEditor = {
  "ed.titleNew": "New campaign",
  "ed.titleEdit": "Edit campaign",
  "ed.name": "Campaign name",
  "ed.name.placeholder": "Vlad [PL] | Joints | Relieflex | 97 ZL | u15",
  "ed.cancel": "Cancel",
  "ed.back": "Back to campaigns",
  "ed.notFound": "Campaign not found",
  "ed.draftSaved": "draft saved {ago} ago",
  "ed.draftLocal": "the draft is kept in this browser",
  "ed.changedAt": "changed {at}",
  "ed.changedUnsaved": "changed {at} · not saved",
  "ed.saved": "Saved — new clicks follow the change",
  "ed.conflict": "The campaign was just changed elsewhere — reload the page",
  "ed.failed": "That did not work — try again",
  "ed.fixFirst": "Something to fix — the section is open",
  "ed.sections": "Campaign sections",
  "ed.legend.ok": "filled",
  "ed.legend.warn": "something to fix",
  "ed.legend.empty": "not filled",
  "ed.legend.opt": "optional",
  "ed.optional": "optional",
  "ed.open": "Open",
  "ed.setUp": "Set up",
  "ed.loading": "loading…",
  "ed.more": "More",
  "ed.remove": "Remove",
  "ed.copy": "Copy",
  "ed.copied": "Copied",
  "ed.retry": "Retry",
  "ed.search.error": "The search failed — the server did not answer",
  "ed.search.empty": "Nothing found",
  "ed.search.navigate": "to move",
  "ed.search.choose": "to choose",
  "ed.source.title": "Source",
  "ed.source.sub": "Where the traffic comes from and where leads go",
  "ed.source.platform": "Platform",
  "ed.source.none": "No sources — add one in Library → Sources",
  "ed.source.clickId": "clicks from {param}",
  "ed.source.pixel": "{brand} pixel",
  "ed.source.pixel.hint": "leads go to the pixel through CAPI",
  "ed.source.leads": "Where the ad leads",
  "ed.source.leads.pick": "Flow scheme",
  "ed.source.leads.graph": "The flow is built by an admin",
  "ed.source.leads.handBuilt": "this campaign's flow is an admin's graph — an admin changes it",
  "ed.source.group": "Group",
  "ed.source.group.hint": "one group per campaign — for the group roll-up",
  "ed.source.group.none": "No group",
  "ed.source.group.search": "Find a group",
  "ed.source.group.count": "campaigns: {n}",
  "ed.source.group.new": "New",
  "ed.source.group.create": "Create group “{name}”",
  "ed.source.groups": "Groups",
  "ed.source.tags": "Tags",
  "ed.source.tags.hint": "free labels for the reports",
  "ed.source.tags.placeholder": "tag…",
  "ed.source.notes": "Notes",
  "ed.offers.title": "Offers and landers",
  "ed.offers.sub": "What a visitor sees and where the lead goes",
  "ed.offers.count": "offers: {offers} · landers: {landers}",
  "ed.offers.how": "A visitor sees a lander by the landers' shares, then goes to an offer by the offers' shares. Flow rules act before the shares.",
  "ed.offers.offers": "Offers",
  "ed.offers.offersNote": "offer shares · sum 100%",
  "ed.offers.landers": "Landers",
  "ed.offers.landersNote": "lander shares · one list for every offer",
  "ed.offers.address": "has an address",
  "ed.offers.noAddress": "no address",
  "ed.offers.shareOf": "Share: {name}",
  "ed.offers.open": "Open the offer",
  "ed.offers.noneOffers": "No offers yet",
  "ed.offers.noneLanders": "No landers yet",
  "ed.offers.addOffer": "Offer",
  "ed.offers.addLander": "Lander",
  "ed.offers.searchOffer": "Find an offer",
  "ed.offers.searchLander": "Find a lander",
  "ed.offers.searchGroup": "Offers",
  "ed.offers.searchGroupIn": "Offers · {countries}",
  "ed.offers.inCampaign": "already here",
  "ed.offers.paused": "paused",
  "ed.offers.otherCountry": "another country",
  "ed.offers.landerEmpty": "not published",
  "ed.offers.split": "shares {split}",
  "ed.offers.sumOk": "shares add up to 100% · ok",
  "ed.offers.sumOff": "shares add up to {sum}% — off by {diff}%",
  "ed.offers.fixSum": "shares add up to {sum}% — make it 100",
  "ed.offers.sticky": "Lander and offer held for 24 hours",
  "ed.offers.sticky.hint": "a returning visitor sees the same lander and offer",
  "ed.offers.thankYou": "Thank-you page",
  "ed.offers.thankYou.hint": "shown after the lander's form is sent",
  "ed.offers.thankYou.default": "the lander's own, else the default",
  "ed.lander.type.landing": "Lander",
  "ed.lander.type.prelanding": "Pre-lander",
  "ed.lander.type.vsl": "VSL",
  "ed.lander.type.white": "White page",
  "ed.lander.type.thanks": "Thank-you",
  "ed.lander.risk.safe": "safe",
  "ed.lander.risk.warn": "at risk",
  "ed.lander.risk.danger": "dangerous",
  "ed.rules.title": "Flow rules",
  "ed.rules.sub": "Who sees what before the shares",
  "ed.rules.n": "Rule {n}",
  "ed.rules.clicks": "{share} of clicks",
  "ed.rules.rest": "Everyone else",
  "ed.rules.restTarget": "by the offers' and landers' shares",
  "ed.rules.shares": "Shares",
  "ed.rules.add": "Rule",
  "ed.rules.edit": "Edit",
  "ed.rules.remove": "Remove the rule",
  "ed.rules.move": "Move — drag, or Alt+↑/↓",
  "ed.rules.order": "Rules are checked top to bottom; the first that matches wins. Drag to reorder. Time is {tz}.",
  "ed.rules.moved": "“{name}” moved to {n}",
  "ed.rules.empty": "No rules — everyone goes by the shares",
  "ed.rules.replayNote": "shares — what each rule would have taken of {total} clicks in {days} days; counted by the server",
  "ed.rules.adminNote": "Complex schemes (several steps, lander to lander) are an admin's. Rules and leaving branches are a buyer's.",
  "ed.rules.handBuilt": "This campaign's flow is an admin's graph — its rules and branches are there, an admin changes them.",
  "ed.rules.openGraph": "Open the graph",
  "ed.rules.kind.offer": "offer",
  "ed.rules.kind.lander": "lander",
  "ed.rules.kind.white": "white page",
  "ed.rules.kind.url": "address",
  "ed.rules.noTarget": "nowhere yet",
  "ed.rules.pickTarget": "Pick…",
  "ed.rules.device.mobile": "phone",
  "ed.rules.device.tablet": "tablet",
  "ed.rules.device.desktop": "computer",
  "ed.rules.w.country": "If the country is {list}",
  "ed.rules.w.countryPre": "If the country is",
  "ed.rules.w.not": "not",
  "ed.rules.w.device": "If the device is {list}",
  "ed.rules.w.bot": "If a bot or a crawler",
  "ed.rules.w.schedule": "If the time is {from}–{to}",
  "ed.rules.w.param": "If the link has no",
  "ed.rules.w.pick": "If …",
  "ed.rules.f.country": "Country",
  "ed.rules.f.device": "Device",
  "ed.rules.f.bot": "Bot",
  "ed.rules.f.botValue": "bot or crawler",
  "ed.rules.f.schedule": "Time",
  "ed.rules.f.param": "Link key",
  "ed.rules.op.notIn": "not in",
  "ed.rules.op.in": "in",
  "ed.rules.op.is": "is",
  "ed.rules.op.hours": "in hours",
  "ed.rules.op.ne": "not",
  "ed.rules.op.paramAbsent": "no key",
  "ed.rules.op.paramPresent": "has key",
  "ed.rules.hoursUnit": "h",
  "ed.rules.days": "Days",
  "ed.rules.daysHint": "none — every day; time is {tz}",
  "ed.rules.dialog.sub": "Acts before the shares. The first matching rule wins.",
  "ed.rules.dialog.field": "Condition",
  "ed.rules.dialog.values": "Values",
  "ed.rules.dialog.outcome": "Then send to",
  "ed.rules.dialog.preview": "How it reads",
  "ed.rules.dialog.save": "Save the rule",
  "ed.rules.dialog.delete": "Delete the rule",
  "ed.rules.replay": "In {days} days the rule would have taken {n} of {total} clicks ({share}).",
  "ed.rules.replay.param": "The tracker keeps no link key — what it would take cannot be counted in advance.",
  "ed.rules.replay.wait": "counting the campaign's clicks…",
  "ed.rules.replay.new": "A new campaign has no clicks yet — shares appear after launch.",
  "ed.day.1": "Mon",
  "ed.day.2": "Tue",
  "ed.day.3": "Wed",
  "ed.day.4": "Thu",
  "ed.day.5": "Fri",
  "ed.day.6": "Sat",
  "ed.day.7": "Sun",
  "ed.branches.title": "Leaving branches",
  "ed.branches.on": "{on} of {total} on",
  "ed.branches.how": "What to show a visitor on the lander who is about to leave. Fires on the lander, not on the click.",
  "ed.branches.handBuilt": "This campaign's branches are nodes of an admin's graph.",
  "ed.branches.back": "The Back button",
  "ed.branches.back.sub": "the visitor presses Back",
  "ed.branches.exit": "Leaving the page",
  "ed.branches.exit.sub": "the cursor heads to close the tab, desktop only",
  "ed.branches.idle": "Idle",
  "ed.branches.idle.sub": "the visitor does nothing",
  "ed.branches.scroll": "Read to the end",
  "ed.branches.scroll.sub": "scrolled to the bottom and did not press the button",
  "ed.branches.idleSeconds": "Seconds without input",
  "ed.branches.idleBounds": "{min} to {max} seconds",
  "ed.branches.sec": "s",
  "ed.branches.where": "Where",
  "ed.branches.search": "Find a lander or an offer",
  "ed.branches.both": "first a lander by its share, then the branch's offer by its share",
  "ed.branches.landersOnly": "from the branch's lander — into the campaign's offers",
  "ed.domain.title": "Domain",
  "ed.domain.sub": "The address the ad link lives on",
  "ed.domain.domain": "Domain",
  "ed.domain.path": "Path",
  "ed.domain.path.placeholder": "from the name",
  "ed.domain.path.auto": "from-the-name",
  "ed.domain.pick": "Pick a domain",
  "ed.domain.search": "Find a domain",
  "ed.domain.own": "My domains",
  "ed.domain.ownBadge": "connect",
  "ed.domain.ownBlocked": "unusable",
  "ed.domain.ownServes": "your domain — the tracker is on it",
  "ed.domain.bound": "Connected",
  "ed.domain.blocked": "Not usable",
  "ed.domain.connect": "Connect a domain…",
  "ed.domain.takeOnSave": "your domain — connected on save",
  "ed.domain.https": "HTTPS issued",
  "ed.domain.httpsShort": "HTTPS",
  "ed.domain.off": "domain is off",
  "ed.domain.dns": "DNS → tracker",
  "ed.domain.dnsFailed": "DNS does not answer",
  "ed.domain.dnsPending": "DNS is being checked",
  "ed.domain.checked": "checked {at}",
  "ed.domain.none": "no domain — the link has nowhere to live",
  "ed.domain.preview": "The link will look like this",
  "ed.cost.title": "Spend",
  "ed.cost.sub": "How the tracker learns what was spent",
  "ed.cost.auto": "From {brand}",
  "ed.cost.auto.hint": "spend per ad arrives every 15 min; needs access to the ad account",
  "ed.cost.auto.notFb": "{brand} does not send spend — pick per click or by hand",
  "ed.cost.cpc": "Per click",
  "ed.cost.cpa": "Per lead",
  "ed.cost.revshare": "Revenue share",
  "ed.cost.manual": "By hand, per period",
  "ed.cost.manual.hint": "for TikTok and sources without an API: the sum is spread over the period's clicks",
  "ed.cost.rate": "Rate",
  "ed.cost.percent": "Percent",
  "ed.cost.perClick": "USD per click",
  "ed.cost.perLead": "USD per lead",
  "ed.cost.from": "From",
  "ed.cost.to": "To",
  "ed.cost.amount": "Amount",
  "ed.cost.usdTotal": "USD total",
  "ed.cost.addPeriod": "Period",
  "ed.cost.overlap": "periods must not overlap",
  "ed.cost.gap": "gap on {day} → that day's spend is 0",
  "ed.cost.total": "periods: {n}, {sum} USD",
  "ed.cost.noPeriods": "no periods yet",
  "ed.cost.currency": "Spend currency",
  "ed.cost.currency.hint": "the tracker counts money in USD",
  "ed.cost.noClicks": "Spend without clicks",
  "ed.cost.noClicks.value": "Shown as its own row",
  "ed.cost.noClicks.hint": "money is not lost when a period has no clicks",
  "ed.postbacks.title": "Postbacks",
  "ed.postbacks.sub": "How the partner reports leads",
  "ed.postbacks.none": "No partner yet — it comes with the first offer",
  "ed.postbacks.template": "{name} template",
  "ed.postbacks.give": "Give this address to {name} — that is how it reports a lead and its status",
  "ed.postbacks.partner": "Partner",
  "ed.postbacks.withTemplate": "{name} · template applied",
  "ed.postbacks.goal": "Goal",
  "ed.postbacks.goal.hint": "set on the partner",
  "ed.postbacks.goal.default": "the workspace's main goal",
  "ed.postbacks.theirs": "{name}'s status",
  "ed.postbacks.ours": "Here",
  "ed.postbacks.noMapping": "No status words — postbacks land on hold until mapped on the partner's card",
  "ed.postbacks.last": "{name}: last postback {ago} ago",
  "ed.postbacks.never": "{name} has not sent a postback yet",
  "ed.postbacks.never.hint": "Send a test one — we check that the statuses map. Real leads come by themselves.",
  "ed.postbacks.never.new": "A test postback — after creating, on a test click.",
  "ed.postbacks.test": "Send a test one",
  "ed.postbacks.testFirst": "A test click first",
  "ed.postbacks.testSent": "Test postback sent — it is in Trash, not in approvals",
  "ed.status.hold": "Hold",
  "ed.status.approved": "Approved",
  "ed.status.rejected": "Rejected",
  "ed.status.refunded": "Refunded",
  "ed.status.trash": "Trash",
  "ed.status.draft": "Draft",
  "ed.status.active": "Active",
  "ed.status.paused": "Paused",
  "ed.status.archived": "Archived",
  "ed.review.title": "Review",
  "ed.review.sub": "What comes out and what is still in the way",
  "ed.review.toFix": "to fix: {n}",
  "ed.review.allOk": "all set",
  "ed.review.openLander": "Open the lander",
  "ed.review.check": "Check",
  "ed.review.fix": "Fix",
  "ed.review.s.clicks": "Clicks from {brand} arrive at",
  "ed.review.s.rest": "Everyone else:",
  "ed.review.s.all": "Everyone:",
  "ed.review.s.landers": "Landers:",
  "ed.review.s.manual": "Spend by hand, periods: {n}, {sum} USD.",
  "ed.review.s.cost": "Spend: {model}.",
  "ed.check.source": "Source",
  "ed.check.source.none": "no platform yet",
  "ed.check.pixel": "pixel {id}",
  "ed.check.pixelHint": "no pixel",
  "ed.check.pixelMissing": "No {brand} pixel",
  "ed.check.offer": "An offer with an address",
  "ed.check.offer.none": "no offer yet",
  "ed.check.offer.noAddress": "“{name}” has no address",
  "ed.check.offer.ok": "{n} · {name}, has an address",
  "ed.check.landers": "Landers published",
  "ed.check.lander.unpublished": "Lander {name} is not published",
  "ed.check.landers.none": "0 of 0",
  "ed.check.landers.n": "{ready} of {total}",
  "ed.check.landers.white": "a white page on the rules",
  "ed.check.white": "White page",
  "ed.check.white.note": "{name} · rules: {n}",
  "ed.check.domain": "Domain",
  "ed.check.domain.own": "{fqdn} · connected on save",
  "ed.check.domain.none": "no domain — the link has nowhere to live",
  "ed.check.postback": "The partner knows the postback",
  "ed.check.postback.unchecked": "{name}'s postback is not checked",
  "ed.check.postback.none": "no partner yet",
  "ed.check.postback.last": "last {ago} ago",
  "ed.check.postback.never": "{name} has not sent a postback yet",
  "ed.check.cost": "Spend",
  "ed.check.cost.auto": "from {brand} automatically",
  "ed.check.cost.manual": "by hand · periods: {n}, {sum} USD",
  "ed.check.cost.manualNone": "by hand · no periods yet",
  "ed.ready.title": "Ready to launch",
  "ed.ready.count": "{ok} of {total}",
  "ed.ready.create": "Create and get the link",
  "ed.ready.create.hint": "you can create with yellow items — the link works, conversions come once the partner sets the postback",
  "ed.ready.save": "Save",
  "ed.ready.save.hint": "new clicks follow the change at once",
  "ed.ready.created": "Campaign created",
  "ed.ready.createdAt": "created {at}",
  "ed.ready.alert": "The campaign is created and takes clicks",
  "ed.ready.alert.sub": "Paste the link into the {brand} ads. The first click shows in the journal within seconds.",
  "ed.ready.draft": "The campaign is created but does not take clicks yet",
  "ed.ready.draft.sub": "It is a draft: the tracker serves no visitor until the campaign is launched. The link can be copied already.",
  "ed.ready.draft.why": "Could not launch: {why}",
  "ed.ready.launch": "Launch",
  "ed.ready.ads": "ads",
  "ed.ready.linkFor": "The link for {brand}",
  "ed.ready.noSource": "The campaign has no source — no link to build",
  "ed.ready.field": "{label} — into “{field}”",
  "ed.ready.address": "The website address in the ad",
  "ed.ready.reports": "What reaches the reports",
  "ed.ready.testClick": "Send a test click",
  "ed.ready.testHint": "goes through the rules like a visitor and shows where it landed",
  "ed.ready.testWaiting": "waiting for the test click…",
  "ed.ready.testArrived": "the test click arrived {ago} ago · {id}",
  "ed.ready.next": "Next",
  "ed.ready.next.postback": "Give {name} the postback",
  "ed.ready.next.postback.sub": "without it leads do not reach the tracker",
  "ed.ready.next.lander": "Publish lander {name}",
  "ed.ready.next.lander.sub": "until then its share goes to the first lander",
  "ed.ready.next.open": "Open the campaign",
  "ed.ready.next.open.sub": "clicks, leads, money — as they come",
  "ed.ready.next.clicks": "Watch clicks live",
  "ed.ready.next.clicks.sub": "the journal filtered to the campaign",
  "ed.unsaved.count": "Unsaved changes: {n}",
  "ed.unsaved.discard": "Discard",
  "ed.changed.name": "name",
  "ed.changed.source": "source",
  "ed.changed.platform": "platform parameters",
  "ed.changed.group": "group",
  "ed.changed.tags": "tags",
  "ed.changed.notes": "notes",
  "ed.changed.template": "flow template",
  "ed.changed.offers": "offer shares",
  "ed.changed.landers": "lander shares",
  "ed.changed.thankYou": "«Thank you» page",
  "ed.changed.rules": "flow rules",
  "ed.changed.branches": "exit branches",
  "ed.changed.domain": "domain",
  "ed.changed.path": "campaign address",
  "ed.changed.cost": "how spend is counted",
  "ed.changed.costPeriods": "spend periods",
  "ed.leave.title": "Leave without saving?",
  "ed.leave.body": "The changes will be lost: {what}. The campaign keeps working as before.",
  "ed.leave.stay": "Stay",
  "ed.leave.go": "Leave without saving",
  "ed.collapsed.offers": "offers: {offers} · landers: {landers}",
  "ed.collapsed.rules": "rules before the shares: {n}",
  "ed.collapsed.noRules": "No rules — everyone goes by the shares",
  "ed.collapsed.branches": "branches on: {n}",
  "ed.collapsed.noBranches": "Not set — a visitor who leaves just leaves.",
  "ed.collapsed.review": "to fix: {n}",
  "match.field.region": "Region",
  "match.field.city": "City",
  "match.field.isp": "ISP (network)",
  "match.field.asn": "ASN",
  "match.field.os": "OS",
  "match.field.browser": "Browser",
  "match.field.device_type": "Device type",
  "match.field.language": "Language",
  "match.field.country": "Country",
  "match.field.ip": "IP address",
  "match.field.user_agent": "User-Agent",
  "match.field.referrer": "Referrer",
  "match.field.param": "Link parameter",
  "match.op.in": "is one of",
  "match.op.not_in": "is none of",
  "match.op.contains": "contains",
  "match.op.not_contains": "does not contain",
  "match.op.regex": "matches regex",
  "match.op.not_regex": "does not match regex",
  "match.op.present": "is present",
  "match.op.not_present": "is absent",
  "match.values.list": "comma-separated; any case",
  "match.values.ip": "addresses or CIDR ranges, v4 or v6, comma-separated",
  "match.values.regex": "one pattern per line; any case; no look-arounds or nested repeats",
  "match.w": "If {field} {op} {values}",
  "ed.rules.f.field": "Field of the visit",
} as const;
